export const certificateNotTrusted = 'Dope root certificate not trusted'
export const certificateNotInstalled = 'Dope root certificate not installed'
export const redirectorNotWorking = 'DopeRedirector is not running'
export const redirectorNotRunning = 'The redirector is not running'

export const redirector_is_approved = 'redirector_is_approved'
export const root_ca_installed = 'root_ca_installed'
export const root_ca_trusted = 'root_ca_trusted'

export const mdmErrorTypes = [
  redirector_is_approved,
  root_ca_installed,
  root_ca_trusted,
]

export const DOWNLOAD_LIMIT = 1000
export const FETCH_ENDPOINTS_MAX_LIMIT = 1000
export const QUERY_LIMIT = 100
export const TOGGLE_ENDPOINT_SIZE = 500
export const DORMANT_STATE_WAIT_IN_DAYS = 35

export const columnHeaderTypes = {
  SELECT_ALL: 'select-all',
}

export const HEALTH_STATUS_THRESHOLD = 20
export const LOWEST_SUPPORTED_MAC_OS_VERSION = 13
